export const mockAppointments = [
  { id: 'APT-5501', date: '2025-07-15', time: '9:00 AM', branch: 'Sector 62', service: 'Comprehensive Health Check', doctor: 'Dr. Meena Rao', status: 'completed', reportReady: true },
  { id: 'APT-5502', date: '2025-06-20', time: '11:30 AM', branch: 'Sector 18', service: 'Thyroid Panel', doctor: 'Dr. Suresh Nair', status: 'completed', reportReady: true },
  { id: 'APT-5503', date: '2025-05-10', time: '8:30 AM', branch: 'Sector 27', service: 'Cardiac Risk Profile', doctor: 'Dr. Anita Sharma', status: 'completed', reportReady: true },
  { id: 'APT-5504', date: '2025-04-05', time: '10:00 AM', branch: 'Sector 62', service: 'Diabetes Screening', doctor: 'Dr. Meena Rao', status: 'completed', reportReady: true },
  { id: 'APT-5505', date: '2025-08-05', time: '9:30 AM', branch: 'Sector 18', service: 'Basic Wellness Panel', doctor: 'Dr. Suresh Nair', status: 'upcoming', reportReady: false },
];

export const mockLabReports = [
  {
    id: 'RPT-7701',
    date: '2025-07-15',
    testName: 'Comprehensive Health Check',
    category: 'General',
    status: 'normal',
    parameters: [
      { name: 'Haemoglobin', value: '14.2 g/dL', range: '13.0–17.0', status: 'normal' },
      { name: 'Blood Glucose (Fasting)', value: '92 mg/dL', range: '70–100', status: 'normal' },
      { name: 'Total Cholesterol', value: '185 mg/dL', range: '<200', status: 'normal' },
      { name: 'TSH', value: '2.1 mIU/L', range: '0.4–4.0', status: 'normal' },
    ],
  },
  {
    id: 'RPT-7702',
    date: '2025-06-20',
    testName: 'Thyroid Panel',
    category: 'Endocrinology',
    status: 'attention',
    parameters: [
      { name: 'TSH', value: '5.8 mIU/L', range: '0.4–4.0', status: 'high' },
      { name: 'Free T3', value: '3.1 pg/mL', range: '2.3–4.2', status: 'normal' },
      { name: 'Free T4', value: '0.9 ng/dL', range: '0.8–1.8', status: 'normal' },
    ],
  },
  {
    id: 'RPT-7703',
    date: '2025-05-10',
    testName: 'Cardiac Risk Profile',
    category: 'Cardiology',
    status: 'normal',
    parameters: [
      { name: 'LDL Cholesterol', value: '98 mg/dL', range: '<130', status: 'normal' },
      { name: 'HDL Cholesterol', value: '52 mg/dL', range: '>40', status: 'normal' },
      { name: 'Triglycerides', value: '142 mg/dL', range: '<150', status: 'normal' },
      { name: 'hs-CRP', value: '1.2 mg/L', range: '<3.0', status: 'normal' },
    ],
  },
  {
    id: 'RPT-7704',
    date: '2025-04-05',
    testName: 'Diabetes Screening',
    category: 'Endocrinology',
    status: 'normal',
    parameters: [
      { name: 'HbA1c', value: '5.4%', range: '<5.7', status: 'normal' },
      { name: 'Fasting Glucose', value: '88 mg/dL', range: '70–100', status: 'normal' },
      { name: 'Post-Prandial Glucose', value: '118 mg/dL', range: '<140', status: 'normal' },
    ],
  },
];

export const healthTrends = [
  { month: 'Jan', glucose: 95, cholesterol: 192, haemoglobin: 13.8 },
  { month: 'Feb', glucose: 91, cholesterol: 188, haemoglobin: 14.0 },
  { month: 'Mar', glucose: 89, cholesterol: 190, haemoglobin: 13.9 },
  { month: 'Apr', glucose: 88, cholesterol: 186, haemoglobin: 14.1 },
  { month: 'May', glucose: 90, cholesterol: 184, haemoglobin: 14.0 },
  { month: 'Jun', glucose: 87, cholesterol: 183, haemoglobin: 14.3 },
  { month: 'Jul', glucose: 92, cholesterol: 185, haemoglobin: 14.2 },
];

export const healthMetrics = {
  overallScore: 86,
  bmi: 22.4,
  bloodPressure: '118/76',
  lastCheckup: '2025-07-15',
  nextDue: '2026-01-15',
  testsCompleted: 4,
  attentionItems: 1,
};
